import React from "react";
import { CheckCircleIcon as CheckCircle, CircleIcon as Circle } from "@phosphor-icons/react";

/**
 * PayoutProgressMeter — "2 of 4 steps done" bar for Stripe Connect setup.
 * Renders nothing without progress data or once setup is complete.
 * Used by StripeConnectBanner, TransporterPayoutsBanner, and Payouts.
 */
export const PayoutProgressMeter = ({ progress }) => {
  if (!progress || !progress.total || progress.done >= progress.total) return null;
  const pct = Math.round((progress.done / progress.total) * 100);
  return (
    <div className="mt-2.5" data-testid="payout-progress-meter">
      <div className="flex items-center justify-between mb-1.5">
        <p className="text-[11px] font-bold uppercase tracking-wider text-ink/70">
          {progress.done} of {progress.total} steps done
        </p>
        <p className="text-[11px] text-[#6B6B6B] font-tabular">{pct}%</p>
      </div>
      <div className="flex gap-1" aria-hidden="true">
        {(progress.steps || []).map((s, i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full ${s.done ? "bg-[#1E9E4A]" : "bg-[#E5E5E5]"}`}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1.5">
        {(progress.steps || []).map((s, i) => (
          <span key={i} className={`inline-flex items-center gap-1 text-[10.5px] ${s.done ? "text-[#1E9E4A]" : "text-[#6B6B6B]"}`}>
            {s.done
              ? <CheckCircle size={11} weight="fill" />
              : <Circle size={11} weight="bold" />}
            {s.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PayoutProgressMeter;
